import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

import { Service } from './Service';
import { AuthGroup } from '../models/authorization.types';


@Injectable({
  providedIn: 'root'
})
export class AuthService extends Service {
  permissions: Array<any>; // Store the actions for which this user has permission

  constructor(
    private _http: HttpClient,
    private toastr: ToastrService,
    private _router: Router
  ) {
    super();
  }

  hasPermission(authGroup: AuthGroup) {
      if (this.permissions && this.permissions.find(permission => {
          return permission.slug === authGroup;
          })) {
          return true;
      }
      this.toastr.error('You don´t have permission to access this resource.', 'Unauthorized');
      this._router.navigate(['dashboard/checkout']);
      return false;
  }

    // This method is called once and a list of permissions is stored in the permissions property
  async initializePermissions(id: number) {
      const this_this = this;
      return await new Promise((resolve, reject) => {
          // Call API to retrieve the list of actions this user is permitted to perform. (Details not provided here.)
          // In this case, the method returns a Promise, but it could have been implemented as an Observable
          this.getPermissions(id).subscribe({
              next(respond: any) {
                  this_this.permissions = respond.permissions;
                  resolve();
              },
              error(msg) {
                  console.log(msg);
                  resolve(false);
              }
          });
      });
  }
  getPermissions(id: number) {
      return this._http.get(this.getApiRoute(`/users/${id}/permissions`), this.headers);
  }

  getRoles(id: number) {
    return this._http.get(this.getApiRoute(`/users/${id}`), this.headers);
  }

  login(body) {
    return this._http.post(this.getApiRoute('/auth/login'), body, this.headers);
  }

  isLogged(): boolean {
    const auth = localStorage.getItem('auth_token');
    if (auth !== 'undefined' && auth !== '' && auth != null) {
      return true;
    } else {
      return false;
    }
  }

  register(body: any) {
    return this._http.post(this.getApiRoute('/auth/register'), body, this.headers);
  }

  registerAdmin(body: any, product: number) {
    return this._http.post(this.getApiRoute(`/admin/register/${product}`), body, this.headers);
  }

  recover(body) {
      return this._http.post(this.getApiRoute('/auth/recovery'), body, this.headers);
  }

  resetPassword(body) {
    return this._http.post(this.getApiRoute('/auth/reset'), body, this.headers);
  }

  logout() {
    /* this._http.post(this.getApiRoute('/auth/logout'), {}, this.headers).subscribe((result: any) => {
      if(result.status){ */
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        location.reload();
      /* }
    }, error => {
      this.toastr.error(error.statusText, "Error")
    }); */
  }
  logoutdashboard() {
    /* this._http.post(this.getApiRoute('/auth/logout'), {}, this.headers).subscribe((result: any) => {
      if(result.status){ */
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
      location.reload();
      /* }
    }, error => {
      this.toastr.error(error.statusText, "Error")
    }); */
  }
  formContact(body) {
      return this._http.post(this.getApiRoute('/form.php'), body, this.headersContact);
  }
  formRegister(body) {
      return this._http.post(this.getApiRoute('/register.php'), body, this.headersContact);
  }
  getCursoStatus(body) {
      return this._http.post(this.getApiRoute('/status.php'), body, this.headersContact);
  }
    /*getCursoStatus(body) {
        return this._http.get(this.getApiRoute(`/landing/orders/status/r1`), this.headersContact);
    }*/
}
